import { render, staticRenderFns } from "./adminStampsUpload.vue?vue&type=template&id=67460a6b"
import script from "./adminStampsUpload.vue?vue&type=script&lang=js"
export * from "./adminStampsUpload.vue?vue&type=script&lang=js"
import style0 from "./adminStampsUpload.vue?vue&type=style&index=0&id=67460a6b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports